import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects'
import store from 'store'
import {
  addReservation,
  reservationSetup,
  getTimeSlot,
  sendOTP,
  resendOTP,
  getDeviceInfo,
  verifyOTP,
  updateCustomer,
} from 'api/reservation'
import phoneFormat from "../../utils/phoneFormat"
import actions from './actions'

export function* GET_RESERVATION_SETUP({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { slug } = payload
  const { response } = yield call(reservationSetup, slug)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        firstForm: true,
        reservationSetupDetails: {
          reservation_interval: response?.data?.reservations_settings?.reservation_interval,
          minimum_time_to_book: response?.data?.reservations_settings?.minimum_time_to_book,
          maximum_time_to_book: response?.data?.reservations_settings?.maximum_time_to_book,
          meal_duration: response?.data?.reservations_settings?.meal_duration,
          is_restaurant_message: response?.data?.reservations_settings?.is_restaurant_message,
          restaurant_message: response?.data?.reservations_settings?.restaurant_message,
          cancellation_policy_message: response?.data?.reservations_settings?.cancellation_policy_message,
          theme_color: response?.data?.reservations_settings?.theme_color,
          background_image_url: response?.data?.reservations_settings?.background_image_url,
        },
        reservationHours: response?.data?.reservations_settings?.reservation_hours,
        blockDates: response?.data?.reservations_settings?.block_dates,
        depositSettings: response?.data?.reservations_settings?.deposit_settings,
        businessDetails: response?.data?.business,
        paymentMode: response?.data?.payment_mode,
        reservationSlots: response?.data?.reservation_slots,
        hideDietaryInstructions: response?.data?.hide_dietary_instructions,
      },
    })
  }
}

export function* GET_TIME_SLOT({ payload }) {
  const { business_id, guest, date } = payload
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { response } = yield call(getTimeSlot, business_id, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        slots: response?.data?.slots,
        covers: guest,
        date,
      },
    })
  }
}

export function* SEND_OTP({ payload }) {
  const { business_id, phone_number, country } = payload
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { response } = yield call(sendOTP, business_id, phone_number, country)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        singInPopUp: false,
        otpPopUp: true,
        phone_number,
        countryCode: country,
      },
    })
  }
}

export function* RESEND_OTP({ payload }) {
  const { business_id, phone_number, country } = payload
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  yield call(resendOTP, business_id, phone_number, country)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
      resendSMS: false,
    },
  })
}

export function* ADD_RESERVATION({ payload }) {
  const { business_id } = payload
  yield put({
    type: actions.SET_STATE,
    payload: {
      savingHour: 'opening',
    },
  })
  delete payload.business_id
  const { response } = yield call(addReservation, business_id, payload)
  yield put({
    type: actions.SET_STATE,
    payload: {
      savingHour: null,
    },
  })
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        reservationPopUp: false,
        successPage: true,
      },
    })
  }
}

function* HANDLE_USER_TOKEN(access_token) {
  store.set(`user.accessToken`, access_token)
  yield put({
    type: actions.SET_STATE,
    payload: {
      accessToken: access_token,
    },
  })
  // yield history.push('/')
}

export function* GET_DEVICE_INFO({ payload }) {
  const { device_id, access_token } = payload
  if (access_token) {
    yield call(HANDLE_USER_TOKEN, access_token)
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { response } = yield call(getDeviceInfo, device_id)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
  if (response) {
    store.set(`user.customerDeviceID`, response?.data?.customer_device_id)
    if (response?.data?.customer?._id) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          customer_device_id: response?.data?.customer_device_id,
          customer_id: response?.data?.customer?._id,
          first_name: response?.data?.customer?.first_name,
          email: response?.data?.customer?.email,
          dietary_instructions: response?.data?.customer?.dietary_instructions,
          accessToken: access_token,
          phone_number: phoneFormat(response?.data?.customer?.phone_number),
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          customer_device_id: response?.data?.customer_device_id,
        },
      })
    }
  }
}

export function* VERIFY_OTP({ payload }) {
  const { business_id, customer_device_id, phone_number, otp_code, is_popup, country } = payload
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { response } = yield call(verifyOTP, business_id, { customer_device_id, phone_number, otp_code, country })
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
  if (response) {
    let firstForm = false
    let profilePopUp = false
    let reservationPopUp = true
    if (!response?.data?.customer?.first_name) {
      firstForm = true
      profilePopUp = true
      reservationPopUp = false
    } else if (is_popup) {
      firstForm = true
      reservationPopUp = false
    }
    const { access_token } = response.data
    yield call(HANDLE_USER_TOKEN, access_token)
    yield put({
      type: actions.SET_STATE,
      payload: {
        firstForm,
        otpPopUp: false,
        profilePopUp,
        reservationPopUp,
        customer_id: response?.data?.customer?._id,
        first_name: response?.data?.customer?.first_name,
        email: response?.data?.customer?.email,
        dietary_instructions: response?.data?.customer?.dietary_instructions,
        accessToken: access_token,
      },
    })
  }
}

export function* UPDATE_CUSTOMER({ payload }) {
  const { business_id, first_name, email, is_popup } = payload
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  let payload_list = {
    first_name,
  }
  if (email) {
    payload_list = {
      first_name,
      email,
    }
  }
  const { response } = yield call(updateCustomer, business_id, payload_list)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
  let firstForm = false
  let reservationPopUp = true
  if (is_popup) {
    firstForm = true
    reservationPopUp = false
  }
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        firstForm,
        profilePopUp: false,
        reservationPopUp,
        first_name: response?.data?.customer?.first_name,
        email: response?.data?.customer?.email,
        is_popup: false,
      },
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.GET_RESERVATION_SETUP, GET_RESERVATION_SETUP),
    takeLatest(actions.GET_TIME_SLOT, GET_TIME_SLOT),
    takeLatest(actions.ADD_RESERVATION, ADD_RESERVATION),
    takeLatest(actions.SEND_OTP, SEND_OTP),
    takeLatest(actions.RESEND_OTP, RESEND_OTP),
    takeLatest(actions.GET_DEVICE_INFO, GET_DEVICE_INFO),
    takeLatest(actions.VERIFY_OTP, VERIFY_OTP),
    takeLatest(actions.UPDATE_CUSTOMER, UPDATE_CUSTOMER),
    takeEvery(actions.HANDLE_USER_TOKEN, HANDLE_USER_TOKEN),
  ])
}
